import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";

import defectCardsStore from "../../store/defectCards";
import { Spinner } from "../../ui-kit";

import ResourceFormTabs from "./resourceFormTabs";
import { IResourceFormProps } from "./interface";
import { CHOICES_LIST } from "./choicesList";
import {
  DEFECT_STATUS_CLOSED_ID,
  DEFECT_STATUS_REMOVED_ID,
} from "../DefectValidator/constants";

const ResourceForm: React.FC<IResourceFormProps> = observer(
  ({ defectId, userId, resourceType, isClose = true }) => {
    const { defectInfoIsLoading, defectInfo } = defectCardsStore;
    const choices = CHOICES_LIST.filter((choice) =>
      resourceType.includes(choice.id),
    );

    useEffect(() => {
      defectCardsStore.getDefectInfo(defectId);
      return () => {
        defectInfoIsLoading.setTrue();
      };
    }, [defectId]);

    if (!choices.length) {
      return <div></div>;
    }

    return defectInfoIsLoading.value ? (
      <Spinner />
    ) : (
      <ResourceFormTabs
        isClose={isClose}
        userId={userId}
        choices={choices}
        defectData={defectInfo}
        isAddMode={!Number(defectId)}
        isReadonly={
          defectInfo &&
          (defectInfo.incidentStatusId == DEFECT_STATUS_CLOSED_ID ||
            defectInfo.incidentStatusId == DEFECT_STATUS_REMOVED_ID)
        }
      />
    );
  },
);

export default ResourceForm;
